import { LiveDurationTask } from './LiveDurationTask';
import { FinalDurationTask } from './FinalDurationTask';

interface Props {
  startAt: string;
  updatedAt?: string;
  country: 'MX' | 'CO';
  action: 'completed' | 'rejected' | 'in_progress' | 'pending';
}

export enum ActionTaskEnum {
  REJECTED = 'rejected',
  COMPLETED = 'completed',
}

export const DurationCell = ({
  startAt,
  updatedAt,
  country,
  action,
}: Props) => {
  const isCompleted =
    action === ActionTaskEnum.COMPLETED || action === ActionTaskEnum.REJECTED;

  if (isCompleted && updatedAt) {
    return (
      <FinalDurationTask
        startAt={startAt}
        updatedAt={updatedAt}
        country={country}
      />
    );
  }

  return <LiveDurationTask startAt={startAt} country={country} />;
};
